import { createRouter as createTanstackRouter } from "@tanstack/react-router";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles.css";
import { getQueryClient } from "@/lib/query-client";

const createRouter = () => {
  const queryClient = getQueryClient();
  return createTanstackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    context: {
      queryClient,
    },
  });
};

type AppRouter = ReturnType<typeof createRouter>;
let clientRouter: AppRouter | null = null;

export const getRouter = () => {
  if (typeof window !== "undefined") {
    if (!clientRouter) {
      clientRouter = createRouter();
    }
    return clientRouter;
  }

  return createRouter();
};

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  // biome-ignore lint/nursery/useConsistentTypeDefinitions: TanStack Router uses interface-based module augmentation.
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
